// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import { ArticleTop } from '@dip/helsecore/src/components/parts/ArticleTop/ArticleTop';
import type { ArticleTopProps } from '@dip/helsecore/src/components/parts/ArticleTop/ArticleTop.d';

export default (props: Readonly<ArticleTopProps>) => <ArticleTop {...props} />
